/**
 * @description 全局Model searchModel 挂载到 redux 上
 */
import { TkitUtils as Utils } from '@tkit/types';
import createModel, { Tction } from '@tkit/model';
import {
  APIS,
  NewGlobalSearchCondition,
  SearchItemCondition,
  ParamssearchArticleUsingGet,
  ParamssearchPageTabUsingGet,
  ParamssearchQuestionUsingGet,
  ParamssearchGlobalUsingGet,
  PageableSearchResultQuestionSimpleInfo,
  PageableSearchResultSingleArticleInfo
} from '@src/services';
import { ParamsquestionQuestionIdCollectUsingPost } from '@src/services/api/QuestionApi';
import * as models from '@services/model/models';

export interface State {
  articleListModel: PageableSearchResultSingleArticleInfo;
  userListModel: SearchItemCondition[];
  tagListModel: SearchItemCondition[];
  groupListModel: SearchItemCondition[];
  teamListModel: SearchItemCondition[];
  askListModel: PageableSearchResultQuestionSimpleInfo;
  searchLoading: boolean;
}

export const searchModelState: State = {
  articleListModel: {},
  userListModel: [],
  tagListModel: [],
  groupListModel: [],
  teamListModel: [],
  askListModel: {},
  searchLoading: false
};

const model = createModel({
  state: searchModelState,
  namespace: 'searchModel',
  reducers: {
    // 搜索文章
    setArticleList: (state, action: Tction<PageableSearchResultSingleArticleInfo>) => {
      return {
        ...state,
        articleListModel: action.payload
      };
    },
    // 搜索文章分页加载
    setArticleListGetNextPage: (state, action: Tction<PageableSearchResultSingleArticleInfo>) => {
      const {
        articleListModel: { list: oldList = [] }
      } = state;
      const { list = [] } = action.payload;
      const articleListModel = {
        ...action.payload,
        list: [...oldList, ...list]
      };

      return {
        ...state,
        articleListModel
      };
    },
    // 搜索问答
    setAskList: (state, action: Tction<PageableSearchResultQuestionSimpleInfo>) => {
      return {
        ...state,
        askListModel: action.payload
      };
    },
    // 搜索问答分页加载
    setMoreAsks: (state, action: Tction<PageableSearchResultQuestionSimpleInfo>) => {
      const {
        askListModel: { list: oldList = [] }
      } = state;
      const { list = [] } = action.payload;

      const askListModel = {
        ...action.payload,
        list: [...oldList, ...list]
      };

      return {
        ...state,
        askListModel
      };
    },
    // 搜索用户
    setUserList: (state, action: Tction<SearchItemCondition[]>) => {
      return {
        ...state,
        userListModel: action.payload
      };
    },
    // 搜索圈子
    setGroupList: (state, action: Tction<SearchItemCondition[]>) => {
      return {
        ...state,
        groupListModel: action.payload
      };
    },
    // 搜索团队
    setTeamList: (state, action: Tction<SearchItemCondition[]>) => {
      return {
        ...state,
        teamListModel: action.payload
      };
    },
    // 搜索标签
    setTagList: (state, action: Tction<SearchItemCondition[]>) => {
      return {
        ...state,
        tagListModel: action.payload
      };
    },
    // 更新问题状态
    updateAskStatus: (state, action: Tction<{ questionIdVal: number; key: string; val: any }>) => {
      const { questionIdVal, key, val } = action.payload;
      const { askListModel } = state;
      const { list } = askListModel;
      if (list) {
        list.map((item: models.QuestionSimpleInfo) => {
          const { questionId } = item;
          if (questionId === questionIdVal) {
            item[key] = val;
          }
        });
      }
      return {
        ...state,
        askListModel
      };
    },
    // 更新loading状态
    updateLoading: (state, action: Tction<boolean>) => {
      return {
        ...state,
        searchLoading: action.payload
      };
    }
  },
  effects: {
    // 搜索文章
    *getArticleList(
      { namespace, put, tPut, tCall },
      action: Tction<ParamssearchArticleUsingGet>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, true);
      const data: Utils.GetROA<typeof APIS.SearchApi.searchArticleUsingGet> = yield tCall(
        APIS.SearchApi.searchArticleUsingGet,
        action.payload
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.setArticleList, data.result);
      }

      yield tPut(model.actions.updateLoading, false);
    },
    /**
     * @description 获取更多文章
     */
    *getMoreArticle(
      { namespace, put, tPut, tCall },
      action: Tction<{ params: ParamssearchArticleUsingGet; callback?: () => void }>
    ): Iterator<{}, any, any> {
      const data: Utils.GetROA<typeof APIS.SearchApi.searchArticleUsingGet> = yield tCall(
        APIS.SearchApi.searchArticleUsingGet,
        action.payload.params
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.setArticleListGetNextPage, data.result);
        action.payload.callback && action.payload.callback();
      }
    },
    // 搜索用户/圈子/团队/标签
    *getList(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamssearchPageTabUsingGet;
        callBack?: (res: SearchItemCondition[]) => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, true);

      const res: Utils.GetROA<typeof APIS.SearchApi.searchPageTabUsingGet> = yield tCall(
        APIS.SearchApi.searchPageTabUsingGet,
        action.payload.params
      );

      if (res.code === 0 && res.result) {
        action.payload.callBack && action.payload.callBack(res.result);
      }

      yield tPut(model.actions.updateLoading, false);
    },
    // 搜索问答
    *getAskList(
      { namespace, put, tPut, tCall },
      action: Tction<{ params: ParamssearchQuestionUsingGet; callBack?: () => void }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, true);
      const data: Utils.GetROA<typeof APIS.SearchApi.searchQuestionUsingGet> = yield tCall(
        APIS.SearchApi.searchQuestionUsingGet,
        action.payload.params
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.setAskList, data.result);
      }

      action.payload.callBack && action.payload.callBack();
      yield tPut(model.actions.updateLoading, false);
    },
    /**
     * @description 获取更多问答
     */
    *getMoreAsks(
      { namespace, put, tPut, tCall },
      action: Tction<{ params: ParamssearchQuestionUsingGet; type?: string; callBack?: () => void }>
    ): Iterator<{}, any, any> {
      const data: Utils.GetROA<typeof APIS.SearchApi.searchQuestionUsingGet> = yield tCall(
        APIS.SearchApi.searchQuestionUsingGet,
        action.payload.params
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.setMoreAsks, data.result);
      }

      action.payload.callBack && action.payload.callBack();
    },
    // 问答关注
    *doFollowHomeQuestion(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsquestionQuestionIdCollectUsingPost;
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        callBack,
        params: { questionId, type }
      } = action.payload;
      const parmsObj = { questionIdVal: questionId, key: 'isAgreeing', val: true };
      yield tPut(model.actions.updateAskStatus, parmsObj);
      const res = yield tCall(APIS.QuestionApi.questionQuestionIdCollectUsingPost, params);
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.updateAskStatus, {
          questionIdVal: questionId,
          key: 'hasFollow',
          val: type
        });
      }
      parmsObj.val = false;
      yield tPut(model.actions.updateAskStatus, parmsObj);
      callBack && callBack(res);
    },
    /**
     * @description 根据关键字全局搜索，返回最佳匹配标签
     */
    *globalSearchAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamssearchGlobalUsingGet;
        callBack?: (res: NewGlobalSearchCondition) => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, true);
      const res: Utils.GetROA<typeof APIS.SearchApi.searchGlobalUsingGet> = yield tCall(
        APIS.SearchApi.searchGlobalUsingGet,
        action.payload.params
      );

      if (res.code === 0 && res.result) {
        action.payload.callBack && action.payload.callBack(res.result);
      }

      yield tPut(model.actions.updateLoading, false);
    }
  }
});

export default model;
